import React from 'react';

export const Add: React.FC<React.SVGProps<SVGSVGElement>> = ({ width, height, color }) => (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={width || '1em'} height={height || '1em'} viewBox="0 0 128 128">
        <path fill={color || 'currentColor'} d="M115,64.8L115,64.8c0,5-4.1,9.2-9.2,9.2H22.2c-5,0-9.2-4.1-9.2-9.2v0c0-5,4.1-9.2,9.2-9.2h83.7C110.9,55.6,115,59.7,115,64.8z"/>
        <path fill={color || 'currentColor'} d="M64,13.8L64,13.8c5,0,9.2,4.1,9.2,9.2v83.7c0,5-4.1,9.2-9.2,9.2h0c-5,0-9.2-4.1-9.2-9.2V22.9C54.8,17.9,59,13.8,64,13.8z"/>
    </svg>
);
